export default "ed78672bcdbd910a.svg"